import api from '../services/api'
import axios from 'axios'
import Vue from 'vue'
import { captureRightsPreviewRequest, prepareRightsPreviewRequest, assertRightsPreviewCurrent, isRightsPreviewCancellation } from '../services/rightsPreviewTransport'

const api2 = axios.create()

// Les promesses restent hors de l'état réactif Vuex, avec une file par store.
const queues = new WeakMap()

const axiosQ = {
    state: {
        listQueue: [],
        axiosLoading: false,
        axiosError: false,
        messageError: [],
        loading: false
    },
    getters: {
        getErrorAPI: state => state.error,
        axiosLoading: state => state.axiosLoading,
        axiosError: state => state.axiosError,
        messageError: state => state.messageError,
        Queue: state => state.listQueue
    },
    mutations: {},
    actions: {
        callAxios: function({ state, dispatch }, query) {
            const previewContext = captureRightsPreviewRequest({ url: query.url, method: query.type, data: query.params, ...query.apidefault })
            let queue = queues.get(state)
            if (!queue) {
                queue = { tail: Promise.resolve(), generation: 0 }
                queues.set(state, queue)
            }
            const generation = queue.generation
            state.listQueue.push(query)
            state.axiosLoading = true

            const execute = async () => {
                try {
                    // Une déconnexion termine aussi les appels déjà en attente.
                    if (generation !== queue.generation) {
                        return { data: { success: false, message: 'noconnect' }, status: 401 }
                    }
                    state.loading = true
                    const external = query.url.includes('https://')
                    const client = external ? api2 : api
                    // Les options appartiennent à l'appel et ne modifient pas
                    // l'instance partagée avec les consommateurs hors file.
                    const config = { ...query.apidefault, _rightsPreviewContext: previewContext }
                    // Capture at enqueue time, not after another view has become active.
                    const prepared = prepareRightsPreviewRequest({ ...config, headers: { ...config.headers }, url: query.url, method: query.type, data: query.params })
                    config.headers = prepared.headers
                    let response
                    if (query.type === 'get') {
                        response = await client.get(query.url, { ...config, params: query.params })
                    } else {
                        if (!external) {
                            config.validateStatus = status => status === 200 || status === 500
                        }
                        response = await client[query.type](query.url, query.params, config)
                    }
                    assertRightsPreviewCurrent(config)
                    if (!external && response.status === 500) {
                        return { data: { success: false, message: response.data.message } }
                    }
                    return response
                } catch (error) {
                    if (isRightsPreviewCancellation(error)) return { data: { success: false, cancelled: true, stale: error.code === 'RIGHTS_PREVIEW_STALE', message: error.message }, status: null }
                    const responseData = error && error.response ? error.response.data : null
                    const message = (responseData && responseData.message) || (error && error.message) || 'Erreur serveur'
                    state.axiosError = true
                    state.messageError.push({ send: query, error })
                    if (message === 'noconnect' && !query.url.includes('https://')) {
                        queue.generation++
                        dispatch('logOut')
                    }
                    dispatch('getoverlay', false)
                    dispatch('loadfalse')
                    if (!query.url.includes('https://')) Vue.$toast.error(message)
                    return {
                        data: { success: false, message, ...(responseData && responseData.errors ? { errors: responseData.errors } : {}) },
                        status: error && error.response ? error.response.status : null
                    }
                } finally {
                    // Même en cas d'échec, libérer la file avant l'appel suivant.
                    state.listQueue = state.listQueue.filter(item => item !== query)
                    state.loading = false
                    state.axiosLoading = state.listQueue.length > 0
                }
            }

            // L'appel suivant démarre dans les microtâches, sans polling ni timer.
            const result = queue.tail.then(execute)
            queue.tail = result.catch(() => {})
            return result
        }
    }
}
export default axiosQ
